import LockupCurrentAudioTrackInfo from './lockupCurrentAudioTrackInfo'

export default LockupCurrentAudioTrackInfo
